var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html } from 'lit';
import { property } from 'lit/decorators.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import { BlocksElement } from '../../BlocksElement';
import styles from '../icon.styles';
/**
 * EmailSend component
 * @csspart base- The component's base wrapper
 */
export class BlocksIconEmailSend extends BlocksElement {
    static { this.styles = styles; }
    connectedCallback() {
        super.connectedCallback();
        this.classList.add('cat-icon');
    }
    render() {
        const componentClassName = this.componentClassNames('cat-c-icon cat-c-icon-bi-directional', {
            'cat-c-icon--sm': this.size === 'sm',
            'cat-c-icon--lg': this.size === 'lg',
            'cat-c-icon--xl': this.size === 'xl',
            'cat-c-icon--content-strong': this.color === 'content-strong',
            'cat-c-icon--knockout': this.color === 'knockout',
            'cat-c-icon--knockout-brand': this.color === 'knockout-brand',
            'cat-c-icon--information': this.color === 'information',
            'cat-c-icon--success': this.color === 'success',
            'cat-c-icon--warning': this.color === 'warning',
            'cat-c-icon--error': this.color === 'error'
        });
        return html `
      <span part="base" class="${componentClassName}" role="presentation">
        <svg
          aria-hidden="${!this.iconTitle}"
          aria-label="${ifDefined(this.iconTitle)}"
          role="${this.iconTitle && 'img'}"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M9.65843 7.28735C9.32234 7.28735 9.03401 7.49185 8.91109 7.78321L15.121 11.8817L21.3311 7.78304C21.2081 7.49177 20.9198 7.28735 20.5838 7.28735H9.65843ZM7.34766 15.902V8.16332C7.34733 8.15056 7.34733 8.13779 7.34766 8.12502V8.09812C7.34766 6.82192 8.38222 5.78735 9.65843 5.78735H20.5838C21.86 5.78735 22.8946 6.82192 22.8946 8.09812V15.902C22.8946 17.1782 21.86 18.2127 20.5838 18.2127H9.65843C8.38222 18.2127 7.34766 17.1782 7.34766 15.902ZM14.7078 13.4063L8.84766 9.53859V15.902C8.84766 16.3497 9.21065 16.7127 9.65843 16.7127H20.5838C21.0316 16.7127 21.3946 16.3497 21.3946 15.902V9.53838L15.5341 13.4063C15.2835 13.5717 14.9584 13.5717 14.7078 13.4063ZM1.85449 6.56763C1.44028 6.56763 1.10449 6.90341 1.10449 7.31763C1.10449 7.73184 1.44028 8.06763 1.85449 8.06763H4.19565C4.60986 8.06763 4.94565 7.73184 4.94565 7.31763C4.94565 6.90341 4.60986 6.56763 4.19565 6.56763H1.85449ZM1.10449 12C1.10449 11.5858 1.44028 11.25 1.85449 11.25H4.19565C4.60986 11.25 4.94565 11.5858 4.94565 12C4.94565 12.4142 4.60986 12.75 4.19565 12.75H1.85449C1.44028 12.75 1.10449 12.4142 1.10449 12ZM1.85449 15.9324C1.44028 15.9324 1.10449 16.2682 1.10449 16.6824C1.10449 17.0966 1.44028 17.4324 1.85449 17.4324H4.19565C4.60986 17.4324 4.94565 17.0966 4.94565 16.6824C4.94565 16.2682 4.60986 15.9324 4.19565 15.9324H1.85449Z"
          />
        </svg>
      </span>
    `;
    }
}
__decorate([
    property({ type: String })
], BlocksIconEmailSend.prototype, "color", void 0);
__decorate([
    property({ type: String })
], BlocksIconEmailSend.prototype, "iconTitle", void 0);
__decorate([
    property({ type: String })
], BlocksIconEmailSend.prototype, "size", void 0);
if (customElements.get('cat-icon-email-send') === undefined) {
    customElements.define('cat-icon-email-send', BlocksIconEmailSend);
}
